<template>
  <div class="main-container nav_menu">
    <div class="logo-container">
      <div class="fl"><a href="/" class="logo"><img :src="logoImg"/></a></div>
      <!--<div class="title fl">体育场馆中心网站</div>-->
      <div class="clear"></div>
    </div>
    <div class="nav_list">
      <el-menu :default-active="currentRouterName" class="el-menu-demo" mode="horizontal" @select="handleSelect"
               :unique-opened="true">
        <el-menu-item index="Home">首页</el-menu-item>
        <el-menu-item index="News">新闻</el-menu-item>
        <el-menu-item index="Venue">场馆介绍</el-menu-item>
        <el-menu-item index="Appointment">场馆预约</el-menu-item>
      </el-menu>
    </div>
    <div class="clear"></div>
  </div>
</template>
<script>
  import logoImg from 'src/assets/images/logo.png'
  import {mapState} from 'vuex'

  export default {
    data () {
      return {
        logoImg: logoImg
      }
    },
    components: {},
    computed: mapState({
      currentRouterName: state => state.currentRouterName
    }),
    mounted () {
      this.$nextTick(function () {
      })
    },
    methods: {
      handleSelect (key, keyPath) {
        if (this.currentRouterName !== key) {
          this.$router.push({
            name: key
          })
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/TopNav.vue